
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256 438.332a304.583 304.583 0 01-49.953-4.146L89.053 499.277V386.429C32.965 345.947 1 287.769 1 225.527 1 108.188 115.391 12.723 256 12.723c140.608 0 255 95.466 255 212.805 0 117.339-114.392 212.804-255 212.804zm-93.93-221.78c-12.639 0-22.886 10.241-22.886 22.875 0 12.633 10.247 22.875 22.886 22.875 12.64 0 22.886-10.242 22.886-22.875.001-12.634-10.246-22.875-22.886-22.875zm82.951 0c-12.64 0-22.886 10.241-22.886 22.875 0 12.633 10.246 22.875 22.886 22.875 12.639 0 22.885-10.242 22.885-22.875 0-12.634-10.246-22.875-22.885-22.875zm85.643 0c-12.64 0-22.886 10.241-22.886 22.875 0 12.633 10.246 22.875 22.886 22.875s22.886-10.242 22.886-22.875c0-12.634-10.246-22.875-22.886-22.875z"}})])
          )
        }
      }
    